import { demoEdgeMockRevision } from './demoEdgeMockRevision';

const createRevisionForVersion = (version) => ({
  ...demoEdgeMockRevision,
  revisionId: `rev-${version}`,
  deploymentName: `Edge Firmware v${version}`,
  deploymentStatus: 'ACTIVE',
});

export const demoEdgeMockFirmwareReleases = [
  {
    version: 'v2.5.1',
    releaseId: 'a3f4b2c8-9d5e-4f7a-b1c3-8e9f2a4b6c8d',
    releaseDate: '2026-02-08T10:00:00Z',
    releaseNotes: {
      version: '2.5.1',
      title: 'Enhanced Performance and Stability Update',
      features: [
        'Improved load balancing algorithm for optimal power distribution across charging stations',
        'Enhanced real-time monitoring capabilities with reduced latency',
        'Critical security patches for IoT communication protocols',
        'Optimized memory management reducing CPU overhead by 15%',
        'Extended support for advanced plaza management strategies',
        'Bug fixes addressing intermittent connection drops during peak hours',
      ],
    },
    revision: createRevisionForVersion('2.5.1'),
  },
  {
    version: 'v2.5.0',
    releaseId: 'b7e9c3d2-4a8f-4e2b-9c5d-7f1a3e8b9d2c',
    releaseDate: '2026-01-22T14:30:00Z',
    releaseNotes: {
      version: '2.5.0',
      title: 'Major Feature Release with Cloud Integration',
      features: [
        'New cloud synchronization protocol for enhanced data consistency',
        'Introduced adaptive scheduling based on grid demand forecasting',
        'Enhanced support for multi-tenant plaza configurations',
        'Improved AWS IoT integration with reduced message overhead',
        'Added automated failover mechanisms for critical operations',
        'Expanded API endpoints for third-party integrations',
      ],
    },
    revision: createRevisionForVersion('2.5.0'),
  },
  {
    version: 'v2.4.9',
    releaseId: 'c4d8a1f5-7e2b-4c9a-8d3f-6b5e9c2a1d7f',
    releaseDate: '2025-12-15T09:00:00Z',
    releaseNotes: {
      version: '2.4.9',
      title: 'Stability Improvements and Bug Fixes',
      features: [
        'Enhanced error handling for network interruptions',
        'Improved diagnostic logging for troubleshooting',
        'Fixed memory leak in telemetry reporting module',
        'Updated charger status synchronization mechanisms',
        'Performance optimizations for plaza-wide load management',
      ],
    },
    revision: createRevisionForVersion('2.4.9'),
  },
  {
    version: 'v2.4.8',
    releaseId: 'd9e3f7a2-5c4b-41e8-9f6a-3d2c8b7e1a9f',
    releaseDate: '2025-11-28T11:15:00Z',
    releaseNotes: {
      version: '2.4.8',
      title: 'Maintenance Release with Critical Fixes',
      features: [
        'Resolved critical issue affecting offline status reporting',
        'Improved connection stability during adverse weather conditions',
        'Enhanced error recovery mechanisms for network failures',
        'Updated cryptographic libraries for improved security',
        'Fixed edge case bugs in charger state machine transitions',
      ],
    },
    revision: createRevisionForVersion('2.4.8'),
  },
  {
    version: 'v2.4.7',
    releaseId: 'e2f5c8d1-3a9b-4e7c-8f2d-9a6b4e1c7f3d',
    releaseDate: '2025-11-05T16:45:00Z',
    releaseNotes: {
      version: '2.4.7',
      title: 'Compatibility and Bug Fix Update',
      features: [
        'Enhanced compatibility with legacy charging hardware',
        'Improved error handling for communication timeouts',
        'Fixed issues with data persistence during power cycles',
        'Updated timezone handling for accurate scheduling',
        'Resolved memory fragmentation in long-running sessions',
      ],
    },
    revision: createRevisionForVersion('2.4.7'),
  },
  {
    version: 'v2.4.6',
    releaseId: 'f8d2a5c3-6e1b-4f9a-7c3e-2b8d5f1a9c4e',
    releaseDate: '2025-10-18T13:20:00Z',
    releaseNotes: {
      version: '2.4.6',
      title: 'Security and Performance Enhancements',
      features: [
        'Applied latest security patches for SSL/TLS protocols',
        'Improved database query performance for telemetry processing',
        'Enhanced monitoring of component health metrics',
        'Fixed intermittent issues with MQTT message delivery',
        'Optimized startup time for edge device initialization',
        'Updated dependencies to address known vulnerabilities',
      ],
    },
    revision: createRevisionForVersion('2.4.6'),
  },
];
